import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const GenericBox = styled(View)`
  width: 100%;
  display: flex;
  flex-direction: ${props => `${props.direction ? props.direction : 'row'}`};
  align-items: center;
  min-height: 73px;
  border-radius: 4px;
  background-color: ${props => `${props.color ? props.color : '#F6F6F6'}`};
  padding: 16px;
`

export default GenericBox
